<template>
  <pt-goods-manage-table class="pt-goods-manage-table__withData" @get-goods-list="getGoodsList" :page-size="pageSize"
  :total-number="totalNumber" :table-data="tableData" :tableLabels="tableLabels" ref="table"
 :loading="loading"  :isOutside="isOutside">
  <slot/>
  </pt-goods-manage-table>
</template>

<script>
import PtGoodsManageTable from './index'
export default {
  name: 'pt-goods-manage-table__withData',
  components: {
    'pt-goods-manage-table': PtGoodsManageTable
  },
  props: {
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    pageSize: {
      type: Number,
      default: 10
    },
    pageCurrent: {
      type: Number,
      default: 0
    },
    queryParams: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isGroupSort: {
      type: Boolean,
      default: false
    },
    isFromRouter: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      page_size: this.pageSize,
      currentPage: 0,
      totalNumber: 50,
      tableData: [],
      loading: false,
      isOutside: false
    }
  },
  watch: {
    queryParams: {
      handler: function (val) {
        if (!this.isFromRouter) {
        //   this.getGoodsList(0)
          this.$refs.table.resetPage()
        } else {
          this.isOutside = true
          this.getGoodsList(this.page)
        }
      },
      deep: true
    }
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  methods: {
    getGoodsList (page, next) {
    //   this.page = page
      let data = {
        ...this.queryParams,
        pageable: {
          page: page,
          size: this.page_size
        //   sort: ['putOnSaleTime,desc', 'id,desc']
        }
      }

      if (!next) {
        this.loading = true
      }
      this.$store.dispatch('salesGoodsSort', data).then(res => {
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        if (next) {
          next(res.data)
        }
        this.loading = false
      }).catch(err => {
        this.loading = false
        this.$refs.table.showReTry()
        this.$message.error(err || '获取商品列表失败')
      })
    }
  }
}
</script>
